<template>
<div id="trackPurchase">

    <v-tabs v-model="tab" @change="resumeSubscription(tab)" class="pl-4">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="(s, index) in sArr" :key="index" :href="'#'+s.name" class="primary--text text-capitalize">
            <span :style="`color:${Constants.PRQStatusColor[s.status[0]]}`">
                {{ s.label }} ({{ $data[s.name + 'Count'] }})
            </span>
        </v-tab>
    </v-tabs>

    <v-card height="40" class="elevation-0 px-8 my-6">
        <v-row>
            <v-col class="pa-0" cols="auto">
                <v-text-field clearable label="Search" outlined @input="onSearch"/>
            </v-col>
            <v-spacer/>
            <datePicker :initial="initialDate" @date="date=$event" @isLastNDays="isLastNDays=$event"
                        :appendToBody="true" opens="left" />
        </v-row>
    </v-card>

    <v-tabs-items v-model="tab" class="px-4">
        <v-tab-item v-for="(s, index) in sArr" :key="index" :value="s.name"> <!-- :loading="$apollo.queries[s.name].loading" -->
            <v-data-table :headers="headers[s.name]"
                          :footerProps="footerProps" class="elevation-0 t-p-table" fixed-header height="calc(100vh - 280px)"
                          :items="$data[s.name]" :server-items-length="$data[s.name+'Count']"
                          :sort-by.sync="$data[s.name+'Options'].sortBy" :sort-desc.sync="$data[s.name+'Options'].sortDesc"
                          :options.sync="$data[s.name+'Options']" @update:options="onUpdateOptions">
                <template v-slot:no-data>No Purchase Request Available</template>
                <template v-slot:no-results>No Purchase Request Available</template>
                <template v-slot:item.productName="{ item:{Product} }">
                    <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(Product.Attachments)" title="View Image">
                        <v-img v-if="Product.Attachments.length" :src="imgWpx(Product.Attachments[0].path, 200)" alt="image">
                            <template v-slot:placeholder>
                                <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                            </template>
                        </v-img>
                    </v-avatar>
                    <span class="ellipsis product-name">
                            <span :title="Product.name">{{ Product.name}}</span><br>
                            <span :title="Product.sku" class="f-12 grey--text text--darken-1">{{Product.sku}}</span>
                    </span>
                </template>
                <template v-slot:item.deliveryDate="{ item }">{{ moment(item.deliveryDate).format('DD-MM-YYYY')}}</template>
                <template v-slot:item.receivedDate="{ item }">{{ moment(item.receivedDate).format('DD-MM-YYYY')}}</template>
                <template v-slot:item.rejectedDate="{ item }">{{ moment(item.rejectedDate).format('DD-MM-YYYY')}}</template>
                <template v-slot:item.biltyNumber="{ item }">
                    <span class="ellipsis bilty-number" :title="item.biltyNumber">{{item.biltyNumber || '-'}}</span>
                </template>
               <!-- <template v-slot:item.actualStock="{ item }">{{ item.Product.WarehouseStock[0].totalQty}}</template> -->
                <template v-slot:item.status="{ item }">
                    <template v-if="s.name === 'confirmedRequests' && [Constants.UserRoles.StockManager, Constants.UserRoles.Admin].includes(user.roleId)">
                        <v-select outlined dense :items="PRQStatuses" v-model="item.statusId" item-text="name" item-value="id"
                                  style="width: 150px; top: 12px; left: calc(100% - 150px)" @change="onChangeStatus(item)"/>
                    </template>
                    <template v-else>{{mapPRQStatuses[item.statusId]}}</template>
                </template>
            </v-data-table>
        </v-tab-item>
    </v-tabs-items>

    <Snackbar :toaster="toaster"/>
    <ChangePRQStatus :dialog.sync="changeStatusDialog" :id.sync="purchaseRequestId" @cancel="onCancelChangeStatus"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-t-p-list" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import {debounce} from 'lodash';
import gallery from '../../mixins/gallery';
import {
    generate_FETCH_PURCHASE_REQUESTS,
    generate_SUBSCRIBE_PURCHASE_REQUESTS_COUNT
} from "../../graphql/subscriptions/PurchaseRequest";
import Snackbar from "../../components/Common/Snackbar";
import DatePicker from "../../components/Common/datePicker";
import ChangePRQStatus from "./ChangePRQStatus";
import updateRecord from '../../mixins/updateRecord';
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
let sArr = [
    {name: 'confirmedRequests', status: [Constants.PRQStatuses.Confirmed], label: 'Pending Purchase'},
    {name: 'receivedRequests', status: [Constants.PRQStatuses.Received], label: 'Received Purchase'},
    {name: 'rejectedRequests', status: [Constants.PRQStatuses.Rejected], label: 'Rejected Purchase'},
];
let qObj = {}, sObj = {}, options = {page: 1, itemsPerPage: 25, offset: 0, limit: 25, sortBy: ['deliveryDate'], sortDesc: [true]};
function commonVariables(s)  {
    return {
        statusId: s.status,
        search: this.search,
        startDate: moment(this.date.startDate, 'YYYY-MM-DD').startOf('day'),
        endDate: moment(this.date.endDate, 'YYYY-MM-DD').endOf('day'),
    }
}
function pageVariables(s) {
    return {
        orderBy: this.prepareSortObject(this[s.name + 'Options'].sortBy, this[s.name + 'Options'].sortDesc),
        offset: this[s.name + 'Options'].offset, limit: this[s.name + 'Options'].limit
    }
}

sArr.forEach(s => {
    /* qObj[s.name] = {                                                          // Smart Query
        query() {return generate_FETCH_PURCHASE_REQUESTS(s.name)},
        skip() {return s.name !== 'confirmedRequests'},
        fetchPolicy: 'network-only',
        variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
        subscribeToMore: {
            document() {return generate_FETCH_PURCHASE_REQUESTS(s.name, 'subscription')},
             skip() {return s.name !== 'confirmedRequests'},           //**important
            variables() {return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
            updateQuery: function(previousQueryResult, {subscriptionData: {data}}) { this[s.name] = data[s.name] }
        },
        result({data}) { this[s.name] = data[s.name]},
    }; */
    sObj[s.name] = {
        query() { return generate_FETCH_PURCHASE_REQUESTS(s.name, 'subscription') },
        skip() {return s.name !== 'confirmedRequests'},
        variables() { return {...commonVariables.call(this, s), ...pageVariables.call(this, s)}},
        result({data}) { this[s.name] = data[s.name] },
    };
    sObj[s.name + 'Count'] = {
        query() { return generate_SUBSCRIBE_PURCHASE_REQUESTS_COUNT(s.name + 'Count') },
        variables() { return {...commonVariables.call(this, s)}},
        result({data}) { this[s.name + 'Count'] = data[s.name + 'Count'].aggregate.count },
    };
});
export default {
    name: "TrackPurchase",
    components: {ConfirmationDialog, ChangePRQStatus, DatePicker, Snackbar},
    mixins: [gallery, updateRecord],
    apollo:{
        $subscribe: {...sObj},
        ...qObj
    },
    data(){
        return{
            Constants, moment,
            user: JSON.parse(localStorage.user),
            tab: 'confirmedRequests',
            sArr: sArr,
            search: '%%',
            ...sArr.reduce((ac, s) => {ac[s.name] = []; ac[s.name + 'Count'] = 0; ac[s.name + 'Options'] = {...options}; return ac}, {}),    // newOrders: []
            columns: [
                { text: 'PRODUCT NAME', value: 'productName', width:370 },
                { text: 'VENDOR CODE', value: 'Vendor.vendorCode', align:'end'},
                { text: 'CARTOONS', value: 'cartoons', align:'end', width:120},
                { text: 'EXP. DELIVERY DATE', value: 'deliveryDate', align:'end'},
                { text: 'ACTUAL DELIVERY DATE', value: 'receivedDate', align:'end'},
                { text: 'REJECTED DATE', value: 'rejectedDate', align:'end'},
                { text: 'BILTY NUMBER', value: 'biltyNumber', align:'end', width:140},
                { text: 'ORDERED STOCK', value: 'totalQty', align:'end'},
                { text: 'ACTUAL RECEIVED STOCK', value: 'receivedStock', align:'end'},
                /* { text: 'ACTUAL STOCK', value: 'actualStock', align:'end', width:100, sortable:false}, */
                { text: 'STATUS', value: 'status', align:'end', sortable:false},
            ],
            headers: {confirmedRequests:[], receivedRequests:[], rejectedRequests:[]},
            footerProps: {'items-per-page-options': [25, 100, 150, 200, -1]},
            date: {startDate: moment(), endDate: moment()},
            initialDate: {startDate: moment().toDate(), endDate: moment().toDate()},
            isLastNDays: false,
            PRQStatuses: [
                {id:Constants.PRQStatuses.Confirmed, name:'Pending'},
                {id:Constants.PRQStatuses.Received, name:'Received'},
                {id:Constants.PRQStatuses.Rejected, name:'Rejected'}
            ],
            mapPRQStatuses:{
                [Constants.PRQStatuses.Confirmed]: 'Pending',
                [Constants.PRQStatuses.Received]: 'Received',
                [Constants.PRQStatuses.Rejected]: 'Rejected'
            },
            toaster: {},
            confirm: {enable: false},
            changeStatusDialog: false,
            purchaseRequestId: null
        }
    },
    created() {
      this.headers.confirmedRequests =  this.columns.filter(c => ['productName', 'Vendor.vendorCode','cartoons','deliveryDate', 'totalQty', 'status'].includes(c.value));
      this.headers.receivedRequests = this.columns.filter(c => ['productName', 'Vendor.vendorCode','cartoons','deliveryDate', 'receivedDate', 'biltyNumber', 'totalQty', 'receivedStock'].includes(c.value));
      this.headers.rejectedRequests =  this.columns.filter(c => ['productName', 'Vendor.vendorCode','cartoons','deliveryDate', 'rejectedDate', 'totalQty'].includes(c.value));
    },
    methods:{
        onChangeStatus(row){
            if(row.statusId === Constants.PRQStatuses.Received){
                this.purchaseRequestId = row.id;
                this.changeStatusDialog = true;
            }else if(row.statusId === Constants.PRQStatuses.Rejected){
                this.confirmStatusChange(row);
            }
        },
        onCancelChangeStatus(){          /* Revert status of Purchase Request */
            this.confirmedRequests.forEach(c => c.statusId = Constants.PRQStatuses.Confirmed)
        },
        confirmStatusChange(row){
            this.confirm = {enable:true, message:'Are you sure want to reject Purchase Request?',
                row, method:this.updatePRQStatus, closeMethod:this.revertPRQStatus};
        },
        async updatePRQStatus(){
            let obj = {statusId:this.confirm.row.statusId, rejectedDate:moment().format(), updatedBy:this.user.id };
            await this.updateRecord(this.confirm.row.id, obj, 'PurchaseRequest');
            this.toaster = {color:'green', enable:true, message: `Purchase Request status updated Successfully`};
            this.closeConfirmPopup();
        },
        revertPRQStatus(){
          this.confirm.row.statusId = Constants.PRQStatuses.Confirmed;
          this.closeConfirmPopup();
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        prepareSortObject([sortBy], [order]) {
            order = order ? 'desc' : 'asc';
            if (['created_at', 'cartoons', 'deliveryDate', 'totalQty', 'receivedStock'].includes(sortBy)) return {[sortBy]: order};
            if (sortBy === 'productName') return {Product: {name: order}};
            if (sortBy === 'Vendor.vendorCode') return {Vendor: {vendorCode: order}};
            return null
        },
        async resumeSubscription(tab) {
            setTimeout(() => this.$apollo.subscriptions[tab].skip = false, 500)
        },
        onUpdateOptions(val) {
            if (val.itemsPerPage === -1) {                                         //'ALL' Rows per page
                this[this.tab + 'Options'].limit = this[this.tab + 'Count'];          //assign total count
                this[this.tab + 'Options'].offset = 0
            } else {
                this[this.tab + 'Options'].limit = val.itemsPerPage;
                this[this.tab + 'Options'].offset = (val.page - 1) * val.itemsPerPage;
            }
        },
        onSearch: debounce(async function (val) {
            this.search = val ? ('%' + val + '%') : '%%';
            sArr.forEach(s => this[s.name + 'Options'] = {...options})          //on search, reset page options
        }, 500)
    },
}
</script>

<style scoped>
#trackPurchase{
    padding: 10px;
}
/deep/ .vue-daterange-picker .dropdown-menu {
    top: 40px;
}

/deep/ .reportrange-text {
    /*width: 212px;*/
    text-align: center;
    padding: 14px 10px;
    border: 1px solid rgba(0, 0, 0, .14);
    margin: 0 0 0 6px;
}
.t-p-table:hover {

}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.product-name {
    display: inline-block;
    vertical-align: middle;
    width: 250px;
    max-width: 250px;
}
.bilty-number {
    display: inline-block;
    vertical-align: middle;
    width: 70px;
    max-width: 70px;
}
</style>
